import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface HeroSlide {
  image: string;
  mobileImage: string;
  title: string;
  description: string;
  ctaText: string;
}

@Component({
    selector: 'app-hero',
    imports: [
        CommonModule,
        TranslateModule
    ],
    templateUrl: './hero.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit, OnDestroy {
  
  slides: HeroSlide[] = [
    {
      image: 'assets/images/web1.jpg',
      mobileImage: 'assets/images/mobile1.png',
      title: 'home.hero.TITLE1',
      description: 'home.hero.DESCRIPTION1',
      ctaText: 'home.hero.CTA'
    },
    {
      image: 'assets/images/web2.jpg',
      mobileImage: 'assets/images/mobile2.png',
      title: 'home.hero.TITLE2',
      description: 'home.hero.DESCRIPTION2',
      ctaText: 'home.hero.CTA'
    },
    {
      image: 'assets/images/web3.jpg',
      mobileImage: 'assets/images/mobile3.png',
      title: 'home.hero.TITLE3',
      description: 'home.hero.DESCRIPTION3',
      ctaText: 'home.hero.CTA'
    }
  ];

  currentSlide = 0;
  private intervalId: any;

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startAutoSlide(): void {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 4000);
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.resetAutoSlide();
  }

  prevSlide(): void {
    this.currentSlide = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    this.resetAutoSlide();
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.resetAutoSlide();
  }

  private resetAutoSlide(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.startAutoSlide();
  }
}